export const cifIt = ["301 201","<g fill-rule='nonzero' fill='none'><path fill='#009246' d='M.5.5h100v200H.5z'/><path fill='#FFF' d='M100.5.5h100v200h-100z'/><path fill='#CE2B37' d='M200.5.5h100v200h-100z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-it.js
// module id = null
// module chunks = 